import React, { useMemo } from 'react';
import { Tag } from 'rsuite';

const NO_APPROVAL_REQUIRED_REASON = 'No approval required';

export default function TimeOffStatusBadge({ status, approvalReason, size }) {
  const { color, label } = useMemo(() => {
    const s = String(status || '').toLowerCase();
    if (s === 'approved') {
      const reason = String(approvalReason || '').trim().toLowerCase();
      if (reason === NO_APPROVAL_REQUIRED_REASON.toLowerCase()) {
        return { color: 'green', label: 'Entered' };
      }
      return { color: 'green', label: 'Approved' };
    }
    if (s === 'rejected') return { color: 'red', label: 'Rejected' };
    if (s === 'cancelled') return { color: 'orange', label: 'Cancelled' };
    return { color: 'cyan', label: 'Pending' };
  }, [approvalReason, status]);

  return <Tag color={color} size={size}>{label}</Tag>;
}
